import makeStyles from "@mui/styles/makeStyles";

export const useDividerStyles = makeStyles((theme) => ({
  root: {
    margin: "8px 0",
    background: theme.palette.grey[300],
  },
}));
